/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _typeof } from './dep-f771ed13.js';

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}

export { _toPropertyKey as _ };
//# sourceMappingURL=dep-5cf1fbb1.js.map
